import React from 'react';
import PropTypes from 'prop-types';

import { NumberInputSelect } from '../../components';
import { translateResourceString } from '../../../util/translationUtility';

import TitlesIncludedInLicense from './TitlesIncludedInLicense';

const maxDropdownQuantity = 10;

class CartItem extends React.Component {
    constructor(props) {
        super(props);
        this.onQuantityChange = this.onQuantityChange.bind(this);
      }

    onQuantityChange(qty) {
        if (qty > 0) {
            this.props.onQuantityChange(this.props.item.Id, Number(qty));
        } else {
            this.props.onDelete(this.props.item.Id, this.props.item.Quantity);
        }
    }

    render() {
        const item = this.props.item;
        //Use restricted quantity text value if it exists. This will show Unlimited if it is used.
        const matchedRestrictedQuantity = item.RestrictedQuantities.find(rq => Number(rq.Value) === item.Quantity);
        const quantity = matchedRestrictedQuantity ? matchedRestrictedQuantity.Text : item.Quantity;
        return (
            <div className="checkout-cart-item d-flex bg-grey-light p-2 mb-2" data-line-item-id={item.Id}>
                <a href={item.Link} title={item.Name}>
                    <img alt={item.Name} className="item-img d-none d-sm-block" src={item.ImageUrl} style={{ "maxWidth": "200px" }} />
                </a>
                <div className="d-flex justify-content-between w-100">
                    <div className="item-info">
                        <div className="item-name">
                            <a href={item.Link} title={item.Name}><h4 className="headline headline-xs">{item.Name}</h4></a>
                        </div>
                        <div className="price-regular fw-600 mb-1">
                            <label className="sr-only">{translateResourceString("/Checkout/Cart/ItemPriceLabel")}</label>
                            <span className="price-regular">{item.Price}</span>
                        </div>
                        <div className="item-meta d-flex text-sm">
                            <label className="sku">{translateResourceString("/Checkout/Cart/ItemSkuLabel")}</label> <span className='sku'>&nbsp; {item.SKU}</span>
                        </div>
                       {item.LicenceDuration &&
                            <div className="license-duration text-sm">
                                <label>{translateResourceString("/Checkout/Cart/LicenseDurationLabel")}</label> <span>{item.LicenseDuration}</span>
                            </div>
                        }
                        {item.Language &&
                            <div className="language text-sm">
                                <label>{translateResourceString("/Checkout/Cart/LanguageLabel")}</label> <span>{item.Language}</span>
                            </div>
                        }
                        {!item.IsStopWorkshop &&
                            <div className="input-container d-flex flex-column">
                                <div className="text-sm">{item.QtyMessage} {quantity}</div>
                                {/* Use this if quantity is editeble
                            {this.props.isEditable &&
                                <NumberInputSelect
                                    className="input-container"
                                    maxDropdownQuantity={maxDropdownQuantity}
                                    componentClassName={"checkout-cart-item-quanity"}
                                    quantity={this.props.item.Quantity}
                                    onChange={this.onQuantityChange}
                                />
                            } */}
                            </div>
                        }
                        {item.TitlesIncluded &&
                            <TitlesIncludedInLicense
                                lineItemId={item.LineItemId}
                                url={this.props.titlesIncludedInLicenseUrl}
                            />
                         }
                    </div>
                    {this.props.isEditable &&
                        <div className="product-list-item-controls">
                            <button title="Delete" className="btn btn-link p-0" onClick={(e) => { e.preventDefault(); this.props.onDelete(item.Id); }}>
                                <span className="sr-only">Delete</span><span className="fas fa-align-right fa-times-circle color-red"></span>
                            </button>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

CartItem.propTypes = {
    item: PropTypes.shape({
        Name: PropTypes.string.isRequired,
        ImageUrl: PropTypes.string.isRequired,
        SKU: PropTypes.string.isRequired,
        Quantity: PropTypes.number.isRequired,
        RestrictedQuantities: PropTypes.arrayOf(
            PropTypes.shape({
                Text: PropTypes.string,
                Value: PropTypes.string,
            })
        ),
    }).isRequired,
    onDelete: PropTypes.func,
    onQuantityChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
}

export default CartItem;
